module.exports = __webpack_public_path__ + "static/media/GTBSProjectPrevieww935@1x.59229104.webp";